/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { getAuth, OAuthProvider, signInWithPopup } from 'firebase/auth';
import {
  Button,
  Card, CardHeader, Col, Row, Spinner
} from "reactstrap";
import Toastr from 'toastr';
import { useLoginMutation } from '../hooks/useLoginMutation';

const Login = () => {
  const { mutate: login, isLoading } = useLoginMutation((err, msg) => {
    if (err) {
      Toastr.error(msg!)
    }
  })
  const handleLogin = async () => {
    if (isLoading) return
    try {
      const provider = new OAuthProvider('microsoft.com')
      provider.setCustomParameters({
        tenant: '0483ae51-a627-466e-a7dd-de2ac7e1238e'
      })
      const auth = getAuth()
      await signInWithPopup(auth, provider)
      const idToken = await auth.currentUser?.getIdToken()
      if (!idToken) {
        throw new Error('no id token obtained!')
      }
      login(idToken)
    } catch (error) {
      console.error(error)
      Toastr.error('Cannot login. Please try again later.')
    }
  }
  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-5">
            <div className="text-muted text-center mt-2 mb-3">
              <h4>Sign In with</h4>
            </div>
            <div className="btn-wrapper text-center">
              <Button
                className="btn-neutral btn-icon"
                color="default"
                onClick={handleLogin}
              >
                {
                  isLoading ?
                    <Spinner style={{ width: '1.25rem', height: '1.25rem' }} /> :
                    <>
                      <span className="btn-inner--icon">

                        <img
                          alt="..."
                          src={
                            require("../assets/img/icons/common/outlook.svg")
                              .default
                          }
                        />

                      </span>
                      <span className="btn-inner--text">Outlook</span>
                    </>
                }
              </Button>
              <Row className="mt-4 justify-content-center">
                <img src="/dir.jpg" alt="logo" width="250px" />
              </Row>
            </div>
          </CardHeader>
        </Card>
      </Col>
    </>
  );
};

export default Login;
